import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
export function useHelpItem() {
    const { t } = useTranslation();
    const { isLoggedIn } = useContext(SessionContext);
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    return {
        key: 'help',
        label: t('siteHeader.userMenu.helpAndFAQ'),
        link: URLS.HELP,
        target: !isMobile && isLoggedIn ? '_blank' : undefined,
        biData: BiData({
            evid: 702,
            link_url: URLS.HELP,
            menu_item: isMobile ? 'help' : 'help_and_faq',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}

//# sourceMappingURL=useHelpItem.js.map